<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    if (!this.me.withdrawalAccount.accountNumber) {
      const name = 'signup/bank/withdrawal'
      if (this.$route.name !== name && this.routerStatusRedirect) {
        this.$router.replace({ name })
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
